const USER_ROLES = {
  ADMIN: 'admin',
  MODERATOR: 'moderator',
  SUPER_UPLOADER: 'super_uploader',
  UPLOADER: 'uploader',
  USER: 'user',
}

export default USER_ROLES
